export const icons = {
  pdf: "https://res.cloudinary.com/df3ajcohw/image/upload/v1633301995/assets/hnvpsqbnbpbcism9qpj4.png",
  text: "https://res.cloudinary.com/df3ajcohw/image/upload/v1633301995/assets/fxbnjmbskjlvygreob5i.png",
};
